import { render, staticRenderFns } from "./SiftSelects.vue?vue&type=template&id=bccb1e92&scoped=true&"
import script from "./SiftSelects.vue?vue&type=script&lang=js&"
export * from "./SiftSelects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccb1e92",
  null
  
)

export default component.exports